import React from 'react'

import BaseTripItemSummaryCard from './BaseTripItemSummaryCard'
import { startPlaceOfTripItem } from '../../utils'

import { usePlaceRating } from 'tripPlanner/hooks/Google/usePlaceRating'
import { TripItem } from 'tripPlanner/types/tripItem'
import { isCustomItem } from 'tripPlanner/utils'

interface Props {
  className?: string
  item: TripItem
  alwaysShadow?: boolean
  showCloseButton?: boolean
  onClose?: () => void
}

const CustomItemSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ className, item, alwaysShadow, showCloseButton, onClose }, ref) => {
    const place = startPlaceOfTripItem(item)
    const { data: rating } = usePlaceRating(
      place?.id ?? '',
      place?.id !== undefined && isCustomItem(item),
    )

    if (!place) {
      return null
    }

    return (
      <BaseTripItemSummaryCard
        ref={ref}
        className={className}
        item={item}
        alwaysShadow={alwaysShadow}
        showCloseButton={showCloseButton}
        onClose={onClose}
        rating={rating}
        place={place}
      />
    )
  },
)

export default CustomItemSummaryCard
